import React, { memo } from 'react';
import DashboardCalendar from './DashboardCalendar';
import { getBookingSummaryCounts } from '../utils/bookingUtils';
import './CalendarPanel.css';

const CalendarPanel = ({
  selectedDate,
  onDateSelect,
  bookings,
  bookingSummaryCounts = null,
  busyTimes,
  venueTimezone = 'Europe/London',
}) => {
  const bookingCounts = bookingSummaryCounts || getBookingSummaryCounts(bookings);

  return (
    <div className="left-panel calendar-panel-wrapper">
      <div className="calendar-section">
        <DashboardCalendar 
          selectedDate={selectedDate}
          onDateSelect={onDateSelect}
          busyTimes={busyTimes || []}
          venueTimezone={venueTimezone}
        />
      </div>
      
      {/* Divider */}
      <div className="booking-summary-divider"></div>
      
      {/* Booking Summary */}
      <div className="booking-summary-section">
        <p className="booking-summary-title">BOOKING SUMMARY</p>
        
        <div className="booking-summary-list">
          {/* Total */}
          <div className="booking-summary-item highlighted">
            <div className="booking-summary-content">
              <p className="booking-summary-label">Total</p>
              <p className="booking-summary-count">{bookingCounts.total}</p>
            </div>
          </div>

          {/* Accepted */}
          <div className="booking-summary-item">
            <div className="booking-summary-content">
              <div className="booking-summary-label-with-dot">
                <div className="status-dot status-dot-accepted"></div>
                <p className="booking-summary-label">Accepted</p>
              </div>
              <p className="booking-summary-count">{bookingCounts.accepted}</p>
            </div>
          </div>

          {/* Pending */}
          <div className="booking-summary-item">
            <div className="booking-summary-content">
              <div className="booking-summary-label-with-dot">
                <div className="status-dot status-dot-pending"></div>
                <p className="booking-summary-label">Pending</p>
              </div>
              <p className="booking-summary-count">{bookingCounts.pending}</p>
            </div>
          </div>

          {/* Paid */}
          <div className="booking-summary-item">
            <div className="booking-summary-content">
              <div className="booking-summary-label-with-dot">
                <div className="status-dot status-dot-paid"></div>
                <p className="booking-summary-label">Paid</p>
              </div>
              <p className="booking-summary-count">{bookingCounts.paid}</p>
            </div>
          </div>

          {/* Canceled */}
          <div className="booking-summary-item">
            <div className="booking-summary-content">
              <div className="booking-summary-label-with-dot">
                <div className="status-dot status-dot-canceled"></div>
                <p className="booking-summary-label">Canceled</p>
              </div>
              <p className="booking-summary-count">{bookingCounts.canceled}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(CalendarPanel);

